<template>
    <portal to="tooltip">
        <div class="tooltip" :class="cssClass" :id="tooltipId">
            <up-arrow/>
            <slot></slot>
        </div>
    </portal>
</template>
<script>
import Popper from 'popper.js';

export default {
    props: ['parent', 'cssClass', 'placement'],
    mounted() {
        setTimeout(() => {
            this.tooltipEl = document.getElementById(this.tooltipId);
            this.arrowEl = this.tooltipEl.querySelector('.up-arrow');

            const options = {
                arrowElement: this.arrowEl,
            };

            if (this.placement) {
                options.placement = this.placement;
            }

            this.tooltip = new Popper(this.parent, this.tooltipEl, options);

            document.addEventListener('click', this.onDocumentClick);
            document.addEventListener('touchend', this.onDocumentClick);
        }, 10);
    },
    computed: {
        tooltipId() {
            return (
                'tooltip-' +
                Math.random()
                    .toString(36)
                    .substr(2, 9)
            );
        },
    },
    methods: {
        onDocumentClick(e) {
            if (e.target.closest(`#${this.tooltipId}`)) {
                return;
            }

            this.$emit('closed');
        },
    },
    destroyed() {
        if (this.tooltip) {
            this.tooltip.destroy();
        }

        document.removeEventListener('click', this.onDocumentClick);
        document.removeEventListener('touchend', this.onDocumentClick);
    },
};
</script>
